import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Avatar from 'components/common/Avatar';
import { useAuth } from 'context/AuthContext';
import { getUserProfileData } from 'helpers/userProfile';
import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

const ProfileDropdown = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout, userData } = useAuth();
  const { initials, displayName, email, companyName, profileName } =
    getUserProfileData(userData);

  const doLogout = async () => {
    await logout();
    navigate('/logout');
  };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar name={initials} isExact size="xl" />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          <div className="px-3 pb-2">
            <div className="d-flex align-items-center">
              <Avatar name={initials} isExact className="me-2" />
              <div className="flex-1">
                <h6 className="mb-0">{displayName}</h6>
                {email ? <div className="fs--2 text-500">{email}</div> : null}
                {companyName || profileName ? (
                  <div className="fs--2 text-600">
                    {[profileName, companyName].filter(Boolean).join(' at ')}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to="/user/profile">
            <FontAwesomeIcon icon="user" className="me-2" fixedWidth />
            {t('USER_PROFILE.DROPDOWN.MY_PROFILE')}
          </Dropdown.Item>
          <Dropdown.Item as={Link} to="/user/settings">
            <FontAwesomeIcon icon="cog" className="me-2" fixedWidth />
            {t('USER_PROFILE.DROPDOWN.SETTINGS')}
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={doLogout}>
            <FontAwesomeIcon icon="sign-out-alt" className="me-2" fixedWidth />
            {t('USER_PROFILE.DROPDOWN.LOGOUT')}
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
